/* eslint-disable react-hooks/exhaustive-deps */
import RoleToggle from "../../components/RoleToggle";
import { useEffect, useState } from "react";
import {
  IconChevronLeft,
  IconCloudDown,
  IconDownload,
  IconEdit,
  IconEye,
} from "@tabler/icons-react";
import { useNavigate, useParams } from "react-router-dom";
import ListView from "../../components/common/ListView";
import ToggleButton from "../../components/ToggleButton";
import ColumnsFilter from "../../components/common/ColumnsFilter";
import DropdownFilter from "../../components/common/DropdownFilter";
import NormalSearch from "../../components/common/NormalSearch";
import {
  useFetchOutSourcesDataDetails,
  useUpdateOutSourceData,
  useFetchOutSourceDriversData,
} from "../../apis/outSourceApis";
import formatDate from "../../utilities/helper";
import AddOutSourceModal from "./_components/AddOutSourceModal";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import NewCommonModal from "../../components/common/NewCommonModal";
import { usePermission } from "../../hooks/usePermissionTabs";
import Pagination from "../../components/common/Pagination";
import { useDriverStatusMutation } from "../../apis/driverApis";
import MessageModal from "../../components/MessageModal";

type FormValues = {
  companyName: string;
  mobileNo: string;
  email: string;
  address: string;
  vatNumber: string;
  vatDoc: File;
  crNumber: string;
  crDoc: File;
  serviceAreaCoverage: string;
  contractStartDate: Date;
  contractEndDate?: Date;
  billingCycle: string;
  contractDoc: File;
  primaryContactName: string;
  primaryContactNumber: string;
  primaryEmailAddress: string;
  warehouseId: string;
  cityId?: string;
  specialization?: string;
  companyLogo: File;
  contactPersonName: string;
};

interface DocumentLinkProps {
  value?: string;
  docUrl?: string;
  label: string;
}

const DocumentLink = ({ value, docUrl, label }: DocumentLinkProps) => {
  if (!value && !docUrl) return null;

  return (
    <div className="flex items-center gap-2">
      {value && <span className="font-medium text-gray-800">{value}</span>}
      {docUrl && (
        <a
          href={docUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-cente hover:bg-[#FBD037]/20 p-0.5 px-1 rounded"
          title={`View ${label} Document`}
          aria-label={`View ${label} Document`}
        >
          <IconCloudDown strokeWidth={1.5} size={22} />
        </a>
      )}
    </div>
  );
};



  const Section = ({
    title,
    children,
  }: {
    title?: string;
    children: React.ReactNode;
  }) => (
    <div className="p-4 bg-[#F7F6F2] rounded-3xl border border-[#EFEFEF] space-y-2">
      {/* <h2 className="text-[#212121]/70 font-medium text-sm">{title}</h2> */}
      <div className="grid lg:grid-cols-4 grid-cols-2 gap-x-6">{children}</div>
    </div>
  );

  const TwoCol = ({
    label,
    value,
  }: {
    label: string;
    value: React.ReactNode;
  }) => (
    <div className="text-sm text-[#212121] flex justify-between items-center gap-1 border-b py-3 last:border-0 px-4">
      <p className="capitalize ">{label}:</p>
      <p className="font-medium capitalize"> {value}</p>
    </div>
  );

export default function ViewOutSourceDetails() {
  const route = useParams();
  const { id } = route;
  const { mutate, isPending } = useUpdateOutSourceData(id);
  const { data, refetch } = useFetchOutSourcesDataDetails(id);
  const [credential, setCredential] = useState<boolean>(false);
  const [pageNo, setPageNo] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [searchFor, setSearchFor] = useState<string>("");
  const { data: driversData, refetch: refetchDrivers } = useFetchOutSourceDriversData(id as string, pageNo, limit, searchFor);

  const [driverId, setDriverId] = useState<string>("");
  const [driverStatus, setDriverStatus] = useState<string>("");

  const { mutate: statusMutate, isPending: isStatusPending } = useDriverStatusMutation(driverId);
  const roles = ["Company Info", "Drivers List"];

  useEffect(() => {
    if (driverId && driverStatus) {
      statusMutate(
        { status: driverStatus === "ACTIVE" ? "INACTIVE" : "ACTIVE" },
        {
          onSuccess: () => {
            refetchDrivers();
            setDriverId("");
            setDriverStatus("");
          },
          onError: (error) => {
            console.log(error, "error");
            toast.error(`${error}`);
            setDriverId("");
            setDriverStatus("");
          },
        },
      );
    }
  }, [driverId, driverStatus]);
  const [selectedDocument, setSelectedDocument] = useState<any>({
    vatDoc: false,
    crDoc: false,
    contractDoc: false,
    companyLogo: false,
  });
  const credentialToggleModal = () => {
    setCredential(!credential);
    if (!credential) return;
    reset();
    clearErrors();
    setSelectedDocument({
      vatDoc: false,
      crDoc: false,
      contractDoc: false,
      companyLogo: false,
    });
  };
  const {
    register,
    handleSubmit,
    clearErrors,
    reset,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm<FormValues>();

  useEffect(() => {
    if (id) {
      refetch();
    }
  }, [id]);


    const { allowed: canUpdateOutSource, isLoading } = usePermission('out_source', 'update');


  const [activeRole, setActiveRole] = useState<string>(
    () => localStorage.getItem("OutSourceDetailsActiveRole") || "Company Info"
  );
  useEffect(() => {
    localStorage.setItem("OutSourceDetailsActiveRole", activeRole);
  }, [activeRole]);

  const navigate = useNavigate();

  const handleUpdateOutSource = (data: any) => {
    let { contractDoc, crDoc, vatDoc, companyLogo, ...otherData } = data;
    mutate(
      {
        ...otherData,
        ...(selectedDocument?.contractDoc && {
          contractDoc: data?.contractDoc,
        }),
        ...(selectedDocument?.vatDoc && { vatDoc: data?.vatDoc }),
        ...(selectedDocument?.crDoc && { crDoc: data?.crDoc }),
        ...(selectedDocument?.companyLogo && {
          companyLogo: data?.companyLogo,
        }),
        ...(watch("companyLogo") && { companyLogoAvailabel: true }),
        ...(watch("vatDoc") && { vatDocAvailabel: true }),
        ...(watch("crDoc") && { crDocAvailabel: true }),
        ...(watch("contractDoc") && { contractDocAvailabel: true }),
      },
      {
        onSuccess: () => {
          credentialToggleModal();
          reset();
          refetch();
          toast.success("Outsource Update Successfully.");
          navigate("/users?tab=Out+Source");
        },
        onError: (error) => {
          console.log(error, "error");
          const errorMessage =
            error?.response?.data?.error?.message ||
            error?.response?.data?.message ||
            error?.message ||
            (typeof error === 'string' ? error : null) ||
            "Failed to Update OutSource.";

          toast.error(errorMessage);
        },
      }
    );
  };

  return (
    <>
      <div className="p-4 pt-0 space-y-4">
        {/* Header */}
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            <button
              onClick={() => navigate(-1)}
              className="p-1.5 border border-[#D2D2D2] rounded-full hover:bg-[#F7F6F2] transition"
            >
              <IconChevronLeft strokeWidth={1.5} size={22} />
            </button>
            <div className="flex items-center gap-2">
              <h1 className="text-xl font-medium text-[#212121] tracking-[-0.5px]  ">
                {data?.companyName}
              </h1>
            </div>
          </div>

          <RoleToggle
            options={roles}
            active={activeRole}
            onChange={setActiveRole}
          />
        </div>

        {/* Sections */}
        <div className="space-y-4">
          {activeRole === "Company Info" && (
            <div className="">
              <Section>
                <div className="flex justify-between items-center lg:col-span-4 col-span-2 pb-3">
                  <h3 className="text-[#212121] font-semibold text-lg  ">
                    Outsource Details{" "}
                  </h3>

                     {canUpdateOutSource && (
                  <button
                    onClick={() => {
                      setCredential(true);
                    }} 
                    className="flex items-center gap-1  p-2.5  text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]"
                  >
                    <IconEdit stroke={1.5} size={24} />
                  </button>
                )}
                </div>
                <div className="bg-[#FCFDF8] border rounded-2xl overflow-hidden mb-4 lg:mb-0">
                  <h3 className="text-[#212121] font-medium text-base capitalize border-b border-gray-300 border-dashed py-2 w-full bg-[#F7F6F2] rounded-t-xl px-4">
                    Company Details
                  </h3>

                  <TwoCol label="Company Name" value={data?.companyName} />
                  <TwoCol
                    label="Contact Person"
                    value={data?.contactPersonName}
                  />
                  <TwoCol label="Mobile Number" value={data?.mobileNo} />
                  <TwoCol label="Email" value={data?.email} />
                  <TwoCol label="Warehouse" value={data?.warehouseName} />
                  <TwoCol label="City" value={data?.cityName} />
                  <TwoCol label="Address" value={data?.address} />
                </div>
                <div className="bg-[#FCFDF8] border rounded-2xl overflow-hidden mb-4 lg:mb-0">
                  <h3 className="text-[#212121] font-medium text-base capitalize border-b border-gray-300 border-dashed py-2 w-full bg-[#F7F6F2] rounded-t-xl px-4">
                    Other Details
                  </h3>
                  <div className="grid grid-cols-1 mt-2">
                    <TwoCol
                      label="Specializations"
                      value={data?.specialization}
                    />
                    <TwoCol
                      label="Billing Cycle"
                      value={data?.billingCycle?.toLowerCase()}
                    />
                    <TwoCol
                      label="Service Area Coverage"
                      value={data?.serviceAreaCoverage}
                    />
                  </div>
                </div>
                <div className="bg-[#FCFDF8] border rounded-2xl overflow-hidden mb-4 lg:mb-0">
                  <h3 className="text-[#212121] font-medium text-base capitalize border-b border-gray-300 border-dashed py-2 w-full bg-[#F7F6F2] rounded-t-xl px-4">
                    Primary Contacts info
                  </h3>
                  <div className="grid grid-cols-1 mt-2">
                    <TwoCol label="Name" value={data?.primaryContactName} />
                    <TwoCol label="Number" value={data?.primaryContactNumber} />
                    <TwoCol label="Email" value={data?.primaryEmailAddress} />
                  </div>
                </div>
                <div className="bg-[#FCFDF8] border rounded-2xl overflow-hidden mb-4 lg:mb-0">
                  <h3 className="text-[#212121] font-medium text-base capitalize border-b border-gray-300 border-dashed py-2 w-full bg-[#F7F6F2] rounded-t-xl px-4">
                    Documents Info
                  </h3>

                  <TwoCol
                    label="Contract Date"
                    value={
                      <DocumentLink
                        value={formatDate(data?.contractStartDate)}
                        docUrl={data?.contractDoc}
                        label="Contract Date"
                      />
                    }
                  />
                  <TwoCol
                    label="Tax/VAT"
                    value={
                      <DocumentLink
                        value={data?.vatNumber}
                        docUrl={data?.vatDoc}
                        label="Vat"
                      />
                    }
                  />
                  <TwoCol
                    label="Cr Number"
                    value={
                      <DocumentLink
                        value={data?.crNumber}
                        docUrl={data?.crDoc}
                        label="CR Doc"
                      />
                    }
                  />
                </div>
              </Section>
            </div>
          )}
          {activeRole === "Drivers List" && (
            <div className="">
              <div className="flex items-center">
                <div className=" bg-[#F7F6F2] flex items-center justify-between px-6 py-3 w-full rounded-tl-3xl rounded-tr-[40px] ">
                  <h1 className="text-xl text-[#212121] tracking-[-0.5px] font-medium">
                    Outsource Driver List
                  </h1>
                  <div className="flex items-center gap-2">
                    <ColumnsFilter columnsData={[]} />
                    <DropdownFilter filterheadings={[]} />
                    <NormalSearch 
                      value={searchFor} 
                      onChange={(e) => {
                        setSearchFor(e.target.value);
                        setPageNo(1);
                      }} 
                    />
                  </div>
                </div>
                <div className="relative ml-5">
                  <div className=" flex items-center gap-2 justify-end rounded-full">
                    <button className="flex items-center gap-1 p-2.5 text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]">
                      <IconDownload stroke={1.5} size={24} />
                    </button>
                  </div>
                </div>
              </div>

              <div className="">
                <ListView
                  data={driversData?.drivers || []}
                  onRowClick={(client) => console.log("Clicked:", client)}
                  columns={[
                    { label: "#", render: (_, i: number) => (pageNo - 1) * limit + (i + 1) },
                    {
                      label: "Name",
                      render: (c: any) => (
                        <div className="flex items-center gap-2 truncate max-w-xs  ">
                          <img
                            src={c?.image || "/img/dummy-blank-profile.png"}
                            alt={c.name}
                            className="w-10 h-10 rounded-full object-cover border"
                          />
                          <span className="truncate text-base font-medium">
                            {c.name}
                          </span>
                        </div>
                      ),
                    },
                    { label: "Driver Code", render: (c: any) => c.driverCode },
                    { label: "Route Code", render: (c: any) => c.routeCodes?.join(",") },
                    { label: "Mobile", render: (c: any) => c.mobileNo },
                    { label: "Email", render: (c: any) => c.email },
                    { label: "Date", render: (c: any) => formatDate(c.createdAt) },
                    {
                      label: "Status",
                      render: (c: any) => (
                        <div className="flex justify-center">
                          <ToggleButton 
                            onChange={() => {
                              setDriverId(c?.id);
                              setDriverStatus(c?.status);
                            }}
                            checked={c?.status === "ACTIVE"} 
                          />
                        </div>
                      ),
                    },
                    {
                      label: "Actions",
                      render: (c: any) => (
                        <div className="flex justify-center">
                          <button onClick={() => navigate(`/driver/${c.id}`)} className="p-2 border rounded-full bg-[#F7F6F2]">
                            <IconEye size={22} />
                          </button>
                        </div>
                      ),
                    },
                  ]}
                />
                <div className="flex justify-center items-center py-4">
                  {driversData?.totalPages > 1 && (
                    <Pagination
                      currentPage={pageNo}
                      totalPages={driversData.totalPages}
                      fetchData={(p) => setPageNo(p)}
                    />
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>



      <NewCommonModal
        title={"Edit Out Source"}
        open={credential}
        closeButtonText={"Cancel"}
        onClose={credentialToggleModal}
        actionButtonText="Update"
        // actionButtonOnClick={credentialToggleModal}
        actionButtonOnClick={handleSubmit(handleUpdateOutSource)}
        isPending={isPending}
      >
        <AddOutSourceModal
          register={register}
          errors={errors}
          setValue={setValue}
          watch={watch}
          clearErrors={clearErrors}
          control={control}
          setSelectedDocument={setSelectedDocument}
          outSourceData={data}
        />
      </NewCommonModal>
    </>
  );
}
